import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=b6d53656&scoped=true&"
import script from "./Activate.vue?vue&type=script&lang=ts&"
export * from "./Activate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d53656",
  null
  
)

export default component.exports